import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useCurrentUser from "../../hooks/useCurrentUser";
import Button from "../../common/Button/Button";

export default function SkipOnboarding() {
  const { currentUser, updateOnboarding } = useCurrentUser();
  const navigate = useNavigate();

  // when the user is updated in the context (using updateUser), this will automatically redirect:
  useEffect(() => {
    if (currentUser.onboarding.done) {
      navigate("/");
    }
  }, [currentUser, navigate]);

  const skipOnboarding = async () => {
    await updateOnboarding({ done: true });
  }

  return (
    <div className="m-4 text-center">
      <h1>SKIP ONBOARDING</h1>
      <p>If you're stuck in onboarding, press the following button to skip it</p>
      <Button variant='primary' onClick={skipOnboarding}>Skip it</Button>
    </div>
  )
}
